import * as vp from 'vopay';
import { FunctionComponent, useEffect } from 'react';
import { useToken } from '../../../providers/Token.provider';
import { useLayout } from '../../../providers/Layout.provider';
import SocialButtons from '../../UI/SocialButtons/SocialButtons';
import BusinessProfileForm from './BusinessProfileForm';

const { Box, Title } = vp;

type FC = FunctionComponent;

const BusinessProfile: FC = () => {
  const defaultValues: vp.IQ11BusinessProfile = {
    CompanyName: '',
    EmailAddress: '',
    PhoneNumber: '',
    Address: '',
    Password: '',
    ConfirmPassword: '',
  };

  const handlers = {
    onCreateBusinessProfile: (_values: vp.IQ11BusinessProfile) => {},
  };
  const { token } = useToken();
  const { setLayoutInfo } = useLayout();

  useEffect(() => {
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'curve',
      '',
      80,
      20,
      0,
      true,
      false,
    );
  }, []);

  return (
    <>
      <Box mb="md" flx="col" height="auto">
        <Title title="Create Your Business Profile" size="lg" bold />
      </Box>

      <BusinessProfileForm defaultValues={defaultValues} handlers={handlers} />

      <SocialButtons title="Connect with" />
    </>
  );
};

export default BusinessProfile;
